import React from "react";
import { InterviewSidebarSection } from "../Components/InterviewSidebarSection";
import { InterviewSidebarPregnancyItem } from "../Components/InterviewSidebarPregnancyItem";

export const InterviewSidebarHouseholdSection = ({ householdMembers, patientName, ...props }) => {
    return (
        <InterviewSidebarSection title="Household" {...props}>
            {householdMembers?.map((member, i) => {
                return (
                    <div className="mini-section">
                        <div className="row">
                            <h4>
                                {member.fullName} ({member.relationshipToPatient})
                            </h4>
                        </div>
                        <div className="row">
                            {member.gender}, {member.age} {member.age > 1 ? "years" : "year"} old.
                        </div>
                        <InterviewSidebarPregnancyItem pregnancy={member.pregnancy} />
                        <div className="row">{member.livesWithPatient && `Lives with ${patientName}.`}</div>
                    </div>
                );
            })}
        </InterviewSidebarSection>
    );
};
